import { CreateExcelPayrollReportISN, CreateExcelPayrollReportINFONAVIT, CreateExcelPayrollINCIDENCIAS } from "../../components/Payroll/Modals/ExcelPayrollReport";
import { formatter } from "../../helpers/formatoMoneda";
import {
  GET_PAYROLLCOLLABORATOR_IMPUESTO,
  GET_EXCEL_TAXES_REPORT_BY_PAYROLL_GROUP,
  GET_ALL_ENTERPRISE
} from "../../Querys/querys";
import { openalertaReporte } from "../../context/PayrollProcess/Actions";
import { server } from "../../global/server";
import { useEffect, useState, useContext } from "react";
import { useLazyQuery, useQuery } from "@apollo/client";
import AlertaReporte from "../Payroll/Modals/AlertaReportes";
import axios from "axios";
import PayrollProcessContext from "../../context/PayrollProcess/PayrollProcessContext";
import styles from "./PayrollStyles.module.css";

const currentDate = new Date();
const year = currentDate.getFullYear();
const currentMonth = currentDate.getMonth() + 1;
const startYear = 2022; // Año inicial definido

const months: { value: number, month: string }[] = [
  { value: 1, month: "Enero" },
  { value: 2, month: "Febrero" },
  { value: 3, month: "Marzo" },
  { value: 4, month: "Abril" },
  { value: 5, month: "Mayo" },
  { value: 6, month: "Junio" },
  { value: 7, month: "Julio" },
  { value: 8, month: "Agosto" },
  { value: 9, month: "Septiembre" },
  { value: 10, month: "Octubre" },
  { value: 11, month: "Noviembre" },
  { value: 12, month: "Diciembre" }
];

const years: { value: string, year: string }[] = [
  { value: "", year: "Selecciona..." },
  { value: "2022", year: "2022" },
  { value: "2023", year: "2023" },
  { value: "2024", year: "2024" },
  { value: "2025", year: "2025" },
  { value: "2026", year: "2026" },
  { value: "2027", year: "2027" },
  { value: "2028", year: "2028" },
  { value: "2029", year: "2029" }
];

const ReportsPayrollTable = () => {
  const { dispatch } = useContext(PayrollProcessContext);
  const [mensajeAlerta, setMensajeAlerta] = useState("");
  const [datos, setDatos] = useState({
    tipoReporte: "",
    Anio: "",
    Mes: 0,
    Enterprise: 0,
  });
  const { data, refetch } = useQuery(
    GET_PAYROLLCOLLABORATOR_IMPUESTO
  );
  const resultado = data?.GET_PAYROLLCOLLABORATOR_IMPUESTO;

  const { data: resultCompany } = useQuery(GET_ALL_ENTERPRISE);
  const allCompanies = resultCompany?.GET_ALL_ENTERPRISE;

  const [getExcelReportByPayRollGroup] = useLazyQuery(GET_EXCEL_TAXES_REPORT_BY_PAYROLL_GROUP);

  useEffect(() => { }, [datos]);

  const cambioDatos = (valor: any, desde: string) => {
    if (desde === "tipoReporte") {
      setDatos({ ...datos, tipoReporte: valor.target.value });
    }
    if (desde === "Anio") {
      setDatos({ ...datos, Anio: valor.target.value });
    }
    if (desde === "Mes") {
      setDatos({ ...datos, Mes: parseInt(valor.target.value) });
    }
    if (desde === "Empresa") {
      setDatos({ ...datos, Enterprise: parseInt(valor.target.value) });
    }
  };

  const consultaReporte = () => {
    switch (true) {
      case datos.tipoReporte === "" && datos.Anio === "" && datos.Mes === 0:
        setMensajeAlerta(
          "Por favor selecciona alguno de los filtros para continuar"
        );
        openalertaReporte({ alertaReporte: true }, dispatch);
        break;
      case datos.tipoReporte === "" && datos.Anio === "" && datos.Mes !== 0:
        setMensajeAlerta("Por favor selecciona Tipo o Año para continuar");
        openalertaReporte({ alertaReporte: true }, dispatch);
        break;
      case datos.tipoReporte !== "" && datos.Anio === "" && datos.Mes !== 0:
        setMensajeAlerta("Por favor selecciona Año para continuar");
        openalertaReporte({ alertaReporte: true }, dispatch);
        break;
      case datos.tipoReporte !== "" && datos.Anio === "" && datos.Mes === 0:
        setMensajeAlerta("Por favor selecciona Año o Mes para continuar");
        openalertaReporte({ alertaReporte: true }, dispatch);
        break;
      case datos.tipoReporte === "" && datos.Anio !== "" && datos.Mes === 0:
        setMensajeAlerta("Por favor selecciona Tipo o Mes para continuar");
        openalertaReporte({ alertaReporte: true }, dispatch);
        break;
      default:
        refetch({
          input: datos,
        });
    }
  };

  const exportarExcel2 = async (TipoReporte: string, Mes: string) => {
    let selectedMonth = ''
    if (TipoReporte !== 'INFONAVIT') {
      const meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      selectedMonth = String(meses.indexOf(Mes) + 1);
    } else {
      const meses = [
        "Enero - Febrero",
        "Marzo - Abril",
        "Mayo - Junio",
        "Julio - Agosto",
        "Septiembre - Octubre",
        "Noviembre - Diciembre",
      ];
      selectedMonth = String((meses.indexOf(Mes) + 1) * 2);
    }

    let variables = {
      input: {
        TipoReporte,
        Anio: datos.Anio,
        Mes: selectedMonth.toString(),
        Enterprise: datos.Enterprise
      },
    };

    const { data: dataReport } = await getExcelReportByPayRollGroup({ variables, });
    const resultReport = JSON.parse(dataReport?.GET_EXCEL_TAXES_REPORT_BY_PAYROLL_GROUP);

    if (resultReport) {
      if (TipoReporte === 'ISN' || TipoReporte === 'ISR' || TipoReporte === 'IMSS') {
        CreateExcelPayrollReportISN(resultReport, TipoReporte);
      }
      else if (TipoReporte === 'INCIDENCIAS') {
        CreateExcelPayrollINCIDENCIAS(resultReport, TipoReporte);
      }
      else {
        CreateExcelPayrollReportINFONAVIT(resultReport, TipoReporte);
      }
    }
  };

  const exportarPDF2 = async (TipoReporte: string, Mes: string) => {
    let selectedMonth = ''
    if (TipoReporte !== 'INFONAVIT') {
      const meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      selectedMonth = String(meses.indexOf(Mes) + 1);
    } else {
      const meses = [
        "Enero - Febrero",
        "Marzo - Abril",
        "Mayo - Junio",
        "Julio - Agosto",
        "Septiembre - Octubre",
        "Noviembre - Diciembre",
      ];
      selectedMonth = String((meses.indexOf(Mes) + 1) * 2);
    }

    const PDF: any = await axios.get(`${server}/report/pdfTaxReport/${TipoReporte}/${datos.Anio}/${selectedMonth}/${datos.Enterprise}`)
    const link = document.createElement("a");
    link.href = PDF?.data?.urlPDF;
    link.setAttribute("download", "downloadtesting.PDF");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <>
      <div className={styles.r_contenedorTitulos}>
        <div className={styles.r_flex}>
          <div className={styles.r_titulo}>Tipo</div>
          <div>
            <select
              name="selectTipo"
              className={styles.r_select}
              onChange={(target) => cambioDatos(target, "tipoReporte")}
            >
              <option value="">Selecciona...</option>
              <option value="IMSS">IMSS</option>
              <option value="INCIDENCIAS">INCIDENCIAS</option>
              <option value="ISR">ISR</option>
              <option value="ISN">ISN</option>
              <option value="INFONAVIT">INFONAVIT</option>
              <option value="FONACOT">FONACOT</option>
            </select>
          </div>
        </div>
        <div className={styles.r_flex}>
          <div className={styles.r_tituloFecha}>A&ntilde;o</div>
          <select
            name="selectTipo"
            className={styles.r_select}
            onChange={(target) => cambioDatos(target, "Anio")}
          >
            <option value="">Selecciona...</option>
            {Array.from({ length: year - startYear + 1 }, (_, i) => startYear + i).map((y) => (
              y <= year ? (
                <option key={y} value={y.toString()}>
                  {y}
                </option>
              ) : null
            ))}
          </select>
        </div>
        <div className={styles.r_flex}>
          <div className={styles.r_tituloFecha}>Mes</div>
          <select
            disabled={!(datos.Anio && datos.Anio.trim())}
            name="selectTipo"
            className={styles.r_select}
            onChange={(target) => cambioDatos(target, "Mes")}
          >
            <option value="0">Selecciona...</option>
            {months.map(({ value, month }) => (
              +datos.Anio === year ? (
                value <= currentMonth ? (
                  <option key={value} value={value}>
                    {month}
                  </option>
                ) : null
              ) : (
                <option key={value} value={value}>
                  {month}
                </option>
              )
            ))}
          </select>
        </div>
        <div className={styles.r_flex}>
          <div className={styles.r_tituloFecha}>Empresa</div>
          <select
            style={{ width: "auto" }}
            name="selectEmpresa"
            className={styles.r_select}
            onChange={(target) => cambioDatos(target, "Empresa")}
          >
            <option value="0">Selecciona...</option>
            {allCompanies?.map((company: any) => (
              <option value={company.id}>{company.name}</option>
            ))}
          </select>
        </div>
        <button
          className={styles.pc_botonCalcular}
          onClick={() => consultaReporte()}
        >
          <div className={styles.pc_iconoCalcular}></div>
          Calcular
        </button>
        <div></div>
      </div>
      <div className={styles.r_contenedorPrincipal}>
        <div className={styles.r_contenedorTarjetas}>
          {resultado?.map((lis: any) => (
            <div className={styles.r_tarjeta}>
              <div className={styles.r_barraTarjeta}></div>
              <div className={styles.r_datosTarjeta}>
                <div className={styles.r_tituloTarjeta}>
                  {lis.Tipo === 'IMSS' ? 'Retenciones IMSS' : lis.Tipo}
                </div>
                <div className={styles.r_subtituloTarjeta}>Mes</div>
                <div className={styles.r_datoTarjeta}>{lis.Mes}</div>
                <div className={styles.r_subtituloTarjeta}>Monto</div>
                <div className={styles.r_datoTarjeta}>
                  {formatter(lis.MontoImpuesto)}
                </div>
                <div className={styles.r_contenedorIconos}>
                  <div
                    className={styles.pt_iconoTarjetasExcel}
                    onClick={() => {
                      exportarExcel2(lis.Tipo, lis.Mes);
                    }}
                  ></div>
                  <div
                    className={styles.pt_iconoTarjetasPDF}
                    onClick={() => {
                      exportarPDF2(lis.Tipo, lis.Mes);
                    }}
                  ></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <AlertaReporte mensaje={mensajeAlerta} />
    </>
  );
};

export default ReportsPayrollTable;
